import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/en/LOGIN', pathMatch: 'full' },
  {
    path: ':lang',
    children: [
      { path: '', redirectTo: 'LOGIN', pathMatch: 'full' },
      { path: '', loadChildren: () => import('./features/features.routes').then(m => m.featureRoutes) },
      { path: 'student', loadChildren: () => import('./modules/student/student.routes') .then(m => m.studentRoutes)},
      { path: '', loadChildren: () => import('./onboarding/onboarding.routes').then(m => m.onboardingRoutes) },
      { path: 'PlacementTest', loadComponent: () => import('./modules/student/components/exercise-components/placement-test/placement-test').then(m => m.PlacementTest), data: { showLayout: false } },
      { path: 'IKnowSomePlacemente', loadComponent: () => import('./modules/student/components/exercise-components/i-know-some-placemente/i-know-some-placemente').then(m => m.IKnowSomePlacemente), data: { showLayout: false } },
    ]
  },
  { path: '**', redirectTo: '/en/LOGIN' }
];